import React from 'react';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from "@material-ui/core/FormHelperText";
import RadioGroup from "@material-ui/core/RadioGroup";

const sanitizeValue = (value) => {
    return value.toString(); // Supposedly FormRadio only supports string values.
};

const FormRadio = ({label, name, value, options, error, touched, onChange, classNameRadio, colorRadio, className,...props}) => (
    <React.Fragment>
        <RadioGroup
            aria-label={label}
            name={name}
            className={className}
            value={sanitizeValue(value)}
            onChange={onChange}
            {...props}
        >
            {options && options.map((option, idx) => {
                if(option) {
                    return (<FormControlLabel key={`option${idx}`} value={sanitizeValue(option.value)} control={<Radio color={colorRadio || "primary"} className={classNameRadio}/>} label={option.label}/>);
                }
            })}
        </RadioGroup>

        {props.controlblock}

        <FormHelperText error={touched && !!error}>
            {(touched && error)}
        </FormHelperText>
    </React.Fragment>
);

export default FormRadio;
